import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home/Home';
import Login from './Login/Login';
import Navbar from './Navbar/Navbar';
import Dashboard from './Dashboard/Dashboard';
import Profile from './Profile/Profile';
import Map from './Map/Map';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mapInstance, setMapInstance] = useState(null);

  const handlePlaceSelected = (location) => {
    if (mapInstance) {
      mapInstance.panTo(location);
      mapInstance.setZoom(14);
    }
  };

  return (
    <Router>
      <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, zIndex: -1 }}>
        <Map setMapInstance={setMapInstance} />
      </div>
      <Navbar isLoggedIn={isLoggedIn} />
      <Routes>
        <Route path="/" exact element={<Home isLoggedIn={isLoggedIn} />} />
        <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/dashboard" element={<Dashboard isLoggedIn={isLoggedIn} mapInstance={mapInstance} onPlaceSelected={handlePlaceSelected} />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </Router>
  );
};

export default App;
